import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const ClientManagementPage = lazy(() => import('../pages/client-management/page'));
const ServerManagementPage = lazy(() => import('../pages/server-management/page'));
const CourtManagementPage = lazy(() => import('../pages/court-management/page'));
const StoreManagementPage = lazy(() => import('../pages/store-management/page'));
const CustomerLoansPage = lazy(() => import('../pages/customer-loans/page'));
const ClientPortalPage = lazy(() => import('../pages/client-portal/page'));
const PDFFieldMapperPage = lazy(() => import('../pages/pdf-field-mapper/page'));
const PDFAutoFillPage = lazy(() => import('../pages/pdf-autofill/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/client-management',
    element: (
      <ProtectedRoute requireAdmin>
        <ClientManagementPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/server-management',
    element: (
      <ProtectedRoute requireAdmin>
        <ServerManagementPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/court-management',
    element: (
      <ProtectedRoute requireAdmin>
        <CourtManagementPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/store-management',
    element: (
      <ProtectedRoute requireAdmin>
        <StoreManagementPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/customer-loans',
    element: (
      <ProtectedRoute requireAdmin>
        <CustomerLoansPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/client-portal',
    element: (
      <ProtectedRoute requireClient>
        <ClientPortalPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/pdf-field-mapper',
    element: (
      <ProtectedRoute requireAdmin>
        <PDFFieldMapperPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/pdf-autofill',
    element: (
      <ProtectedRoute requireAdmin>
        <PDFAutoFillPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/404',
    element: <NotFoundPage />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

export default routes;
